import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CanonicalLink = () => {
    const location = useLocation();

    useEffect(() => {
        // The base domain for the canonical URL
        const cleanPath = location.pathname.replace(/\/+$/, '') || '/';
        // If we are at root, keep it simple, otherwise append path
        const canonicalUrl = `https://www.apptek.dev${cleanPath === '/' ? '' : cleanPath}`;

        // Find existing canonical link or create valid one
        let link = document.querySelector("link[rel='canonical']");

        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            document.head.appendChild(link);
        }

        link.setAttribute('href', canonicalUrl);

    }, [location.pathname]);

    return null;
};

export default CanonicalLink;
